import { render, staticRenderFns } from "./ModalUpdateClient.vue?vue&type=template&id=a6a2b402"
import script from "./ModalUpdateClient.vue?vue&type=script&lang=js"
export * from "./ModalUpdateClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports